// @todo handle nested routes
export default (sourceRoutes) => {
  return flatten(sourceRoutes.map(parse))
}

function flatten(routes) {
  return routes.reduce((a, b) => a.concat(b), []);
}

function parse(sourceRoute) {
  let routes = sourceRoute
  if (!_.isArray(sourceRoute) && _.isObject(sourceRoute)) {
    const {routes: generic = [], ...guards} = sourceRoute
    routes = [...generic, ...parseGuards(guards)]
  }
  return routes
}

function parseGuards(guards) {
  let routes = _.map(guards, (list, guard) => {
    list.forEach(item => {
      (item.guards || (item.guards = [])).push(guard)
    })
    return list
  })
  return flatten(routes)
}

